import { TagInterface, TagStatisticApiInterface } from 'modules/tags/types/tag-interface'

export const getTagStatistic = (tag: TagInterface, statistics?: TagStatisticApiInterface) => {
  if (!statistics) {
    return null
  }

  return statistics.items.find(stat => stat.id === tag.id)?.statistics
}
